<template>
    <main-content>
        <settlements :changeStatus="changeStatus"></settlements>
        <Empty v-if="status === 'loading'"></Empty>
    </main-content>
</template>

<script>
import MainContent from '@/components/main-content';
import Empty from '@/pages/settlements/settlements_empty';
import Settlements from '@/pages/settlements/settlements';

export default {
    name: 'Get',
    data() {
        return {
            status: 'loading',
            current_tab: 'settlement_list',
        };
    },
    components: { Settlements, MainContent, Empty },
    methods: {
        changeStatus(status) {
            this.status = status;
        },
        setTab(tab) {
            this.current_tab = tab;
        },
    }
};
</script>

<style scoped></style>
